import * as React from 'react'

export const SVG_Play = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="59" height="59" viewBox="0 0 59 59">
        <g fill="none" fillRule="evenodd" transform="translate(.525 -.388)">
            <ellipse cx="28.92" cy="29.49" fill="#1C2533" fillOpacity=".623" rx="28.92" ry="29.01" />
            <path fill="#FFF" d="M22.572 20.909l7.329 4.348 7.328 4.233-7.328 4.485-7.329 4.095z" />
        </g>
    </svg>
)
